var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cp-service" }, [
    _vm._m(0),
    _vm._m(1),
    _c("div", { attrs: { id: "maintenance" } }, [
      _c("div", { staticClass: "w" }, [
        _c("h2", [_vm._v("报修方式")]),
        _c("h3", [_vm._v("Maintenance")]),
        _vm.isMobile
          ? _c(
              "div",
              { staticClass: "tab-wrap-mobile" },
              [
                _c(
                  "div",
                  { staticClass: "tab", class: [_vm.currentMobileTab.name] },
                  [
                    _c("h4", [_vm._v(_vm._s(_vm.currentMobileTab.title))]),
                    _c("p", {
                      domProps: { innerHTML: _vm._s(_vm.currentMobileTab.info) }
                    }),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.mobileTabIndex > 0,
                            expression: "mobileTabIndex > 0"
                          }
                        ],
                        staticClass: "btn-prev",
                        on: { click: _vm.prevTab }
                      },
                      [_vm._v("<")]
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.mobileTabIndex < _vm.typeList.length - 1,
                            expression: "mobileTabIndex < (typeList.length-1)"
                          }
                        ],
                        staticClass: "btn-next",
                        on: { click: _vm.nextTab }
                      },
                      [_vm._v(">")]
                    )
                  ]
                ),
                _vm._l(_vm.typeList, function(item, index) {
                  return _c("div", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: index === _vm.mobileTabIndex,
                        expression: "index === mobileTabIndex"
                      }
                    ],
                    staticClass: "img",
                    class: [item.name]
                  })
                })
              ],
              2
            )
          : _c(
              "div",
              { staticClass: "tab-wrap" },
              _vm._l(_vm.typeList, function(item) {
                return _c(
                  "div",
                  {
                    staticClass: "tab",
                    class: [{ active: _vm.tab === item.name }, item.name],
                    on: {
                      mouseover: function($event) {
                        _vm.setTab(item.name)
                      }
                    }
                  },
                  [
                    _c("h4", [_vm._v(_vm._s(item.title))]),
                    _c("p", { domProps: { innerHTML: _vm._s(item.info) } }),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: item.name === _vm.tab,
                          expression: "item.name === tab"
                        }
                      ],
                      staticClass: "img",
                      class: [item.name]
                    })
                  ]
                )
              })
            ),
        _vm._m(2)
      ])
    ]),
    _c("div", { attrs: { id: "qa" } }, [
      _c("div", { staticClass: "w" }, [
        _c("h2", [_vm._v("服务问答")]),
        _c("h3", [_vm._v("Questions & Answers")]),
        _c(
          "div",
          { staticClass: "list" },
          _vm._l(_vm.qaList, function(item) {
            return _c("div", { staticClass: "item ani-card" }, [
              _c("p", [
                _c("i", { staticClass: "icon q" }, [_vm._v("Q")]),
                _c("span", { staticClass: "q" }, [
                  _vm._v(_vm._s(item.question))
                ])
              ]),
              _c("p", [
                _c("i", { staticClass: "icon a" }, [_vm._v("A")]),
                _c("span", [_vm._v(_vm._s(item.answer))])
              ])
            ])
          })
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "banner" }, [
      _c("p", { staticClass: "p1" }, [_vm._v("服务")]),
      _c("p", { staticClass: "p2" }, [_vm._v("SERVICE")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "after-sale" } }, [
      _c("div", { staticClass: "w" }, [
        _c("h2", [_vm._v("售后服务")]),
        _c("h3", [_vm._v("After-sale Service")]),
        _c("div", { staticClass: "info1" }, [
          _c("div", { staticClass: "item item1 ani-card" }, [
            _c("h4", [_vm._v("适用产品")]),
            _c("p", [_vm._v("弗徕威智能服务机器人产品")])
          ]),
          _c("div", { staticClass: "item item2 ani-card" }, [
            _c("h4", [_vm._v("保修期限")]),
            _c("p", [_c("b", [_vm._v("整机：")]), _c("span", [_vm._v("1年")])]),
            _c("p", [
              _c("b", [_vm._v("主要部件（如电机）：")]),
              _c("span", [_vm._v("1年")])
            ]),
            _c("p", [
              _c("b", [_vm._v("配套智能设备及电池：")]),
              _c("span", [_vm._v("6个月")])
            ])
          ]),
          _c("div", { staticClass: "item item3 ani-card" }, [
            _c("h4", [_vm._v("维修方式")]),
            _c("p", [
              _vm._v(
                "通过正规快递寄回弗徕威售后服务中心维修，维修完毕后会联系您寄出，产品包装箱请妥善保管，以便产品维修时使用"
              )
            ])
          ])
        ]),
        _c("div", { staticClass: "info2 ani-card" }, [
          _c("h4", [_vm._v("维修费用")]),
          _c("p", [
            _vm._v("保修期内：非使用不当原因造成的产品损坏，弗徕威负责免费维修")
          ]),
          _c("p", [
            _vm._v(
              "保修期外：由消费者付费维修，弗徕威会根据损坏状况收取一定维修费用（含快递费用）"
            )
          ])
        ]),
        _c("div", { staticClass: "tip" }, [
          _vm._v(
            "以上政策适用于消费者在中国大陆所购买的弗徕威产品，并遵循中国相关的“三包”规定"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tip" }, [
      _vm._v("服务时间为"),
      _c("b", [_vm._v("周一至周五9:00-18:00")]),
      _vm._v("，法定节假日休息。"),
      _c("br"),
      _vm._v(
        "报修时明确告知您所使用的产品型号、产品序列号、详细的故障现象等，以便快捷为您服务。"
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c0f8379e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0f8379e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/service.vue
// module id = bp4M
// module chunks = 0